import { useEffect } from 'react';
import { blokkieTheme } from '@tikkie/blokkie';

interface Props {
  children: React.ReactNode;
  backgroundColor?: string;
}

export function LayoutContainer({
  children,
  backgroundColor = blokkieTheme.colors.secondary.veryDarkPurple,
}: Props) {
  useEffect(() => {
    const root = document.getElementById('root');

    if (!root) {
      return;
    }

    root.style.backgroundColor = backgroundColor;
  }, [backgroundColor]);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: blokkieTheme.breakpoints.largePhone.max,
        margin: '0 auto',
      }}
    >
      {children}
    </div>
  );
}
